import { render, staticRenderFns } from "./bomScan.vue?vue&type=template&id=660ccc4e&scoped=true&"
import script from "./bomScan.vue?vue&type=script&lang=js&"
export * from "./bomScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660ccc4e",
  null
  
)

export default component.exports